import type { MongoEntity } from '@adornis/baseql/entities/mongoEntity';
import type { BuildifyExtension } from '@adornis/buildify/client/globals/types';
import type { Base } from '@adornis/buildify/db/Base';
import { MarketingBuildifyGlobalSettings } from '@adornis/digitale-helden-shared/db/buildify/DigitaleHeldenBuildifyGlobalSettings';
import { VisualizeBuildify } from '@adornis/digitale-helden-shared/features/buildify/client/VisualizeBuildify';
import { MarketingDraft, type Draft } from '@adornis/digitale-helden-shared/features/drafts/db/Draft';
import { stateful } from '@adornis/functional-lit/stateful';
import { html } from 'lit';
import { getMarketingBuildifyExtensions } from '../../../buildify/client/helpers';
import { loggedInUser } from '../../../client/startup';
import { MarketingCustomContent } from '../../../db/MarketingCustomContent';

export const MarketingVisualizeBuildify = stateful(
  ({
    value,
    mode = 'view',
    onNavigateBackCallback,
    onSaveCallback,
    addActionButtons = false,
    entityData,
    onAfterCorrectionCreated,
    getExtensions,
  }: {
    value: Base[];
    mode?: 'view' | 'edit';
    onNavigateBackCallback?: () => void;
    onSaveCallback?: () => Promise<void>;
    addActionButtons?: boolean;
    entityData: MongoEntity;
    onAfterCorrectionCreated?: (draft: Draft) => void;
    getExtensions?: () => Promise<BuildifyExtension[]>;
  }) => {
    return html`
      ${VisualizeBuildify({
        value,
        mode,
        getExtensions: getExtensions ?? getMarketingBuildifyExtensions,
        customContent: MarketingCustomContent,
        onNavigateBackCallback,
        onSaveCallback,
        addActionButtons,
        entityData,
        user: loggedInUser,
        onAfterCorrectionCreated,
        globalSettingsClassName: MarketingBuildifyGlobalSettings._class,
        draftClassName: MarketingDraft._class,
      })}
    `;
  },
);
